import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import { TextField } from 'rmwc/TextField';
import { Radio } from 'rmwc/Radio';
import {Button} from 'rmwc/Button';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';


class AdminSeminarAddChange extends Component {

  constructor(props){
    super(props);
    this.state = {
      errorMsg: '',
      initialLoadingComplete: false,
      addUpdateDisable: false,
      data:{
        id: 0,
        name: '',
        iconLink:'',
        eventDate: '',
        description: '',
        regLink: '',
        active: '',
        listingSequence: '',
        sessionNo: '',
        seminarNameInCertificate: '',
        seminarResourceId: '',
        facilitator: '',
        competencyList: [],
        selectedCompetency: [],
        selectedCompetencyIds: [],
        seminarMappings: [],
        selectedSeminarMappingArray: [],
        destroySeminarMappingArray: [],
      },
      formErrors:{
        nameError: '',
        iconLinkError:'',
        eventDateError: '',
        descriptionError: '',
        regLinkError: '',
        activeError: '',
        listingSequenceError: '',
        sessionNoError: '',
        seminarNameInCertificateError: '',
        facilitatorErr: '',
        competencyErr: ''
      },
    }
  }
  
  componentDidMount(){

    let data = Object.assign({}, this.state.data)
    let seminarId = parseInt(this.props.match.params.id)
    data.id = seminarId
      api.getResponse(this.props.user.accessToken, 'admin/taxonomy_details/2')
        .then((result) => {
          data.competencyList = result.data
          if(seminarId === 0){
            this.setState({data:data, initialLoadingComplete:true})
          }  else { 
            this.fetchDetails(data)
          }
        })
      .catch((err) => {
       this.setState({ errorMsg: 'Exception in Fetching Details'})
     })
  }

  fetchDetails = (data) => {
    //call Api to fetch details
    let url ='admin/selected/seminar/'+this.props.match.params.id
    api.getResponse(this.props.user.accessToken, url)
      .then((result) => {
        const { status, errors} = result
        if (status === 'success') {
          data.id = result.data.id ? result.data.id : ''
          data.name = result.data.name ? result.data.name : '' 
          data.iconLink = result.data.icon_link ? result.data.icon_link : ''
          data.eventDate = result.data.event_date ? result.data.event_date : '' 
          data.description = result.data.description ? result.data.description : ''
          data.regLink = result.data.reg_link ? result.data.reg_link : ''
          data.active = result.data.active ? result.data.active : ''
          data.listingSequence = result.data.listing_sequence ? result.data.listing_sequence : ''
          data.sessionNo = result.data.session_no ? result.data.session_no : ''
          data.seminarNameInCertificate = result.data.full_name ? result.data.full_name : ''
          data.seminarResourceId = result.data.ext_resource_id ? result.data.ext_resource_id : ''
          data.facilitator =  result.data.facilitator ? result.data.facilitator : ''
          data.seminarMappings = result.data.seminar_mapping ? result.data.seminar_mapping : ''
            let selectedCompetency = data.competencyList.filter((competency) => data.seminarMappings.some(seminarMapping => seminarMapping.item_id === competency.value));   
            data.selectedCompetency = selectedCompetency

            let selectedSeminarMappingArray = []
            let finalArray = data.seminarMappings.filter(competency => data.selectedCompetency.some(selectedCompetency => competency.item_id === selectedCompetency.value)); 
            selectedSeminarMappingArray.push(finalArray)
            data.selectedSeminarMappingArray = selectedSeminarMappingArray
          this.setState({data, initialLoadingComplete: true})
        } else {
          this.setState({ errorMsg: 'Error in Fetching Details'})
        }
      })
    .catch((err) => {
     this.setState({ errorMsg: 'Exception in Fetching Details'})
   })
}

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  }

  handleCompetencyChange = (option) => {
    let data = Object.assign({}, this.state.data)
    data.selectedCompetency = option
    this.setState({ data })
  }

  validateForm = () => {
    
    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    
    errorObj.nameError = ''
    errorObj.iconLinkError = ''
    errorObj.eventDateError = ''
    errorObj.descriptionError = ''
    errorObj.regLinkError = ''
    errorObj.activeError = ''
    errorObj.listingSequenceError = ''
    errorObj.sessionNoError = ''
    errorObj.seminarNameInCertificateError = ''
    errorObj.facilitatorErr = ''
    errorObj.competencyErr = ''


    if(data.name === ''){
        errorObj.nameError ='Name is mandatory'
        error = false
    }

     if(data.iconLink === ''){
        errorObj.iconLinkError ='Icon Link is mandatory'
        error = false
    }

     if(data.eventDate === ''){
        errorObj.eventDateError ='Event Date is mandatory'
        error = false
    }

     if(data.description === ''){
        errorObj.descriptionError ='Description is mandatory'
        error = false
    }

     if(data.regLink === ''){
        errorObj.regLinkError ='Registration Link is mandatory'
        error = false
    }

     if(data.active === ''){
        errorObj.activeError ='Status is mandatory'
        error = false
    }

     if(data.listingSequence === ''){
        errorObj.listingSequenceError ='Listing Sequence is mandatory'
        error = false
    }

    if(!data.sessionNo){
      errorObj.sessionNoError = 'Session Number is mandatory'
      error = false
    }

    if(!data.seminarNameInCertificate){
      errorObj.seminarNameInCertificateError = 'Seminar name to be provided in certificate is mandatory'
      error = false
    }

    if(!data.facilitator){
      errorObj.facilitatorErr = 'facilitator field is mandatory'
      error = false
    }

    if(data.selectedCompetency.length === 0) {
      errorObj.competencyErr = 'Competency field is mandatory'
      error = false
    }

    this.setState({formErrors:errorObj, errorMsg:''})
    return error

  }

  handleAddSeminar = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)

    if(this.validateForm()){
      let url ='admin/new/seminar'
      let apiInput = {
        'name': this.state.data.name,
        'icon_link': this.state.data.iconLink,
        'event_date': this.state.data.eventDate,
        'description': this.state.data.description,
        'reg_link': this.state.data.regLink,
        'active': this.state.data.active,
        'listing_sequence': this.state.data.listingSequence,
        'session_no': this.state.data.sessionNo,
        'full_name': this.state.data.seminarNameInCertificate,
        'ext_resource_id': this.state.data.seminarResourceId,
        'facilitator': this.state.data.facilitator,
      }

      let selectedCompetencyIds = []
      if (data.selectedCompetency && data.selectedCompetency.length > 0) {
        data.selectedCompetency.forEach( (competency) => (
          selectedCompetencyIds.push({
            "item_type": "Learning Taxonomy",
            "active" : 1,
            "item_id": competency.value
          })
        ))
        apiInput.seminar_mappings_attributes = selectedCompetencyIds
      }
      api.postValuesApi(this.props.user.accessToken, url, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          this.setState({ errorMsg: result.message, addUpdateDisable: true })
        } 
        else{
          this.setState({ errorMsg: result.message })
        }    
        
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
  } 

  handleUpdateSeminar = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)

    if(this.validateForm()){
      let url = 'admin/update/seminar/'+this.state.data.id
      let apiInput = {
        'id': this.state.data.id,
        'name': this.state.data.name,
        'icon_link': this.state.data.iconLink,
        'event_date': this.state.data.eventDate,
        'description': this.state.data.description,
        'reg_link': this.state.data.regLink,
        'active': this.state.data.active,
        'listing_sequence': this.state.data.listingSequence,
        'session_no': this.state.data.sessionNo,
        'full_name': this.state.data.seminarNameInCertificate,
        'ext_resource_id': this.state.data.seminarResourceId,
        'facilitator': this.state.data.facilitator
      }
      
    let finalSelectedCompetency = [], destroySeminarMappingArray = []

    if (data.selectedCompetency && data.selectedCompetency.length > 0) {
      data.selectedCompetency.map( (competency) => {

       let id =  data.selectedSeminarMappingArray[0]
        .filter( (eachItem) => {
          return eachItem.item_id === competency.value
        }).map( (finalObject) => {
          return finalObject.id
        })

        finalSelectedCompetency.push({
          "id": parseInt(id),
          "item_type": "Learning Taxonomy",
          "active" : 1,
          "item_id": competency.value,
          "_destroy": 0,
        })
      })
    } 

      let destroyCompetencyArray = data.seminarMappings.filter(competency => !data.selectedCompetency.some(selectedCompetency => competency.item_id === selectedCompetency.value)); 
      destroyCompetencyArray.forEach( (eachcompetency) => {
        eachcompetency._destroy = 1
      });

      let finalSeminarAttributes = [...finalSelectedCompetency, ...destroyCompetencyArray]
      apiInput.seminar_mappings_attributes = finalSeminarAttributes
      api.putValuesApi(this.props.user.accessToken, url, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          this.setState({ errorMsg: result.message, addUpdateDisable: true })
        } 
        else{
          this.setState({ errorMsg: result.message })
        }    
        
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
  }

  handleBackAction = (e) => {
      e.preventDefault()
      this.props.history.push('/portal/app/admin/seminar/list')
    }

  render() {
    let data = Object.assign({}, this.state.data)
    let formComponents

    let buttonComponent

    if(this.state.data.id === 0){
      buttonComponent=<Button raised onClick={this.handleAddSeminar} disabled={this.state.addUpdateDisable}>Add</Button>
    }
    else if (this.state.data.id > 0){
      buttonComponent=<Button raised onClick={this.handleUpdateSeminar} disabled={this.state.addUpdateDisable}>Update</Button>
    }
    
    if(this.state.initialLoadingComplete){
      formComponents = (<Grid>
        
        <GridCell span="4">
          <TextField fullwidth className='text_input' label="Seminar Name" autoComplete="off" name="name" onChange={this.onInputChange} value={this.state.data.name}/>
        </GridCell>

        <GridCell span="8">
          <TextField fullwidth className='text_input' label="Seminar Full Name" autoComplete="off" name="seminarNameInCertificate" onChange={this.onInputChange} value={this.state.data.seminarNameInCertificate}/>
        </GridCell>


        <GridCell span="12">
          <TextField fullwidth className='text_input' label="Registraiton Link" autoComplete="off" name="regLink" onChange={this.onInputChange} value={this.state.data.regLink}/>
        </GridCell>
       

        <GridCell span="12">
          <TextField fullwidth className='text_input' label="Description" autoComplete="off" name="description" onChange={this.onInputChange} value={this.state.data.description}/>
        </GridCell>
        

        <GridCell span="6">
          <TextField type="date" className="datepicker-padding" label="Event Date" autoComplete="off" name="eventDate" onChange={this.onInputChange} value={this.state.data.eventDate}/>  
        </GridCell>
        <GridCell span="6"></GridCell>

        <GridCell span="6">
          Status:
          <Radio name="active" value={1} checked={this.state.data.active == '1'} onChange={this.onInputChange}> Active </Radio>
          <Radio name="active" value={0} checked={this.state.data.active == '0'} onChange={this.onInputChange}> In Active </Radio>
        </GridCell>
        <GridCell span="6"></GridCell>

        <GridCell span="12">
          <TextField fullwidth className='text_input' label="Icon Link" autoComplete="off" name="iconLink" onChange={this.onInputChange} value={this.state.data.iconLink}/>
        </GridCell>

        <GridCell span="4">
          <TextField fullwidth type="number" className='text_input' label="listing Sequence" autoComplete="off" name="listingSequence" onChange={this.onInputChange} value={this.state.data.listingSequence}/>
        </GridCell>
        <GridCell span="4">
          <TextField fullwidth type ="number" className='text_input' label="Session Number" autoComplete="off" name="sessionNo" onChange={this.onInputChange} value={this.state.data.sessionNo}/>
        </GridCell>
        <GridCell span="4">
          <TextField fullwidth type ="number" className='text_input' label="Resource Id" autoComplete="off" name="seminarResourceId" onChange={this.onInputChange} value={this.state.data.seminarResourceId}/>
        </GridCell>
        <GridCell span="8">
          <Reactsel 
            name="selectedCompetency"
            onChange={this.handleCompetencyChange}
            value={data.selectedCompetency}
            options={data.competencyList}
            placeholder="-- Select Competency --"
            isMulti>
          </Reactsel>
        </GridCell>
        <GridCell span="12">
          <TextField fullwidth className='text_input' label="facilitator" autoComplete="off" name="facilitator" onChange={this.onInputChange} value={this.state.data.facilitator}/>
        </GridCell>
        <GridCell span="12">
          <Typography use="subtitle2">Note: Please include the Resource id from <b>Blog URL.</b></Typography>
        </GridCell>
      </Grid>)

    }
    else{
      formComponents = (<Typography style={{margin: '25px'}} use="headline6">Loading... Please wait...</Typography>)
    }

    return(
      <div>
        
        <Card style={{padding: '1px'}}>
          <Grid>
            <GridCell span="10">
              <Typography use="headline5">Seminar Add / Update</Typography>
            </GridCell>
            <GridCell span="2">
              <Button raised onClick = {((e) => this.handleBackAction(e))}>Back</Button>
            </GridCell>
          </Grid>
        </Card>
        <br/>
       {formComponents}
        
        <Grid>
          <GridCell span="12">
            <StatusMessage error_msg = {this.state.errorMsg}/>
            <StatusMessage error_msg = {this.state.formErrors.nameError}/>
            <StatusMessage error_msg = {this.state.formErrors.iconLinkError}/>
            <StatusMessage error_msg = {this.state.formErrors.eventDateError}/>
            <StatusMessage error_msg = {this.state.formErrors.descriptionError}/>
            <StatusMessage error_msg = {this.state.formErrors.regLinkError}/>
            <StatusMessage error_msg = {this.state.formErrors.activeError}/>
            <StatusMessage error_msg = {this.state.formErrors.listingSequenceError}/>
            <StatusMessage error_msg = {this.state.formErrors.sessionNoError}/>
            <StatusMessage error_msg = {this.state.formErrors.seminarNameInCertificateError}/>
            <StatusMessage error_msg = {this.state.formErrors.facilitatorErr}/>
            <StatusMessage error_msg = {this.state.formErrors.competencyErr}/>
          </GridCell>
          <GridCell span="6">
            {buttonComponent}
          </GridCell>
          <GridCell span="6"></GridCell>
        </Grid> 
      
      </div>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSeminarAddChange);


// WEBPACK FOOTER //
// ./src/views/admin/AdminSeminarAddChange.jsx